<template>
	<span class="warning-feedback">
		<i class="icon icon-warning-01"></i>
		<ul class="warning-feedback__items">
			<li
				class="warning-feedback__item"
				v-for="message in warningMessages"
				:key="message"
			>
				{{ message }}
			</li>
		</ul>
	</span>
</template>

<script>
export default {
	name: 'WarningFeedback',
	props: {
		warningMessages: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
// UI/UX Note: review and tweek for a case with multiples messages

.warning-feedback {
	display: flex;
	font-size: $field-warning-font-size;
	margin-top: $gutter-sm;
	padding: $padding-xs;
	background-color: var(--ui-warning-light);
	border-radius: $border-radius;
	border: 1px solid var(--ui-warning);
	width: fit-content;

	& .icon {
		color: $ui-fg-dark;
		font-size: $field-icon-warning-help-font-size;
	}

	&__items {
		display: inline-flex;
		flex-direction: column;
		min-width: calc(
			100% - (14px + #{$gutter-sm})
		); //icon container width + the right margin
		color: $ui-fg-dark;
	}

	&__item {
		display: inline-block;
		vertical-align: middle;
		width: 100%;
	}

	> *:first-child {
		margin-right: $gutter-sm;
	}
}
</style>
